import { useState } from "react";
import { TYPE_META } from "./ActivityLogPanel";

const MANUAL_TYPES = Object.entries(TYPE_META);
const TODAY = () => new Date().toISOString().slice(0, 10);

export default function QuickLogModal({ clientName, initialData, onAdd, onSave, onClose }) {
  const [form, setForm] = useState(initialData || {
    type: "meeting",
    description: "",
    amount: "",
    feeCollected: false,
    date: TODAY(),
    dueDate: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.description.trim()) return;
    const payload = {
      type: form.type,
      description: form.description.trim(),
      clientName: form.clientName || clientName || undefined,
      ...(form.type === "fee" ? {
        amount: Number(form.amount) || undefined,
        feeCollected: form.feeCollected,
      } : {}),
      ...(form.type === "task" ? {
        dueDate: form.dueDate || undefined,
        done: false,
      } : {}),
      date: form.date || TODAY(),
    };
    if (onSave) onSave(payload);
    else if (onAdd) onAdd(payload);
    onClose();
  };

  const meta = TYPE_META[form.type];

  return (
    <div
      onClick={onClose}
      style={{
        position: "fixed", inset: 0, zIndex: 4000,
        background: "rgba(15,23,42,0.4)",
        display: "flex", alignItems: "center", justifyContent: "center",
        direction: "rtl",
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          background: "white", borderRadius: 14,
          width: 380, maxWidth: "90vw",
          boxShadow: "0 20px 50px rgba(0,0,0,0.2)",
          overflow: "hidden",
        }}
      >
        {/* Header */}
        <div style={{
          padding: "12px 16px",
          background: meta?.color + "12" || "#f8fafc",
          borderBottom: "1px solid #e2e8f0",
          display: "flex", justifyContent: "space-between", alignItems: "center",
        }}>
          <button onClick={onClose} style={iconBtn}>✕</button>
          <span style={{ fontSize: 14, fontWeight: 800, color: "#1e293b" }}>
            {meta?.icon} {initialData ? "ערוך פעולה" : "הוסף פעולה"} — {form.clientName || clientName || "ללא לקוח"}
          </span>
          <div style={{ width: 24 }} />
        </div>

        <form onSubmit={handleSubmit} style={{ padding: "16px", display: "flex", flexDirection: "column", gap: 12 }}>

          {/* Type + Date */}
          <div style={{ display: "flex", gap: 10 }}>
            <label style={{ ...labelStyle, flex: 1 }}>
              <span style={labelText}>סוג</span>
              <select value={form.type} onChange={e => setForm(f => ({ ...f, type: e.target.value }))} style={inputStyle}>
                {MANUAL_TYPES.map(([k, v]) => <option key={k} value={k}>{v.icon} {v.label}</option>)}
              </select>
            </label>
            <label style={{ ...labelStyle, flex: "0 0 120px" }}>
              <span style={labelText}>{form.type === "task" ? "תאריך יעד" : "תאריך"}</span>
              <input
                type="date"
                value={form.type === "task" ? form.dueDate : form.date}
                onChange={e => setForm(f => form.type === "task"
                  ? { ...f, dueDate: e.target.value }
                  : { ...f, date: e.target.value }
                )}
                style={inputStyle}
              />
            </label>
          </div>

          {/* Fee extras */}
          {form.type === "fee" && (
            <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
              <label style={{ ...labelStyle, flex: 1 }}>
                <span style={labelText}>סכום שסוכם ₪</span>
                <input type="number" placeholder="0" min={0} value={form.amount}
                  onChange={e => setForm(f => ({ ...f, amount: e.target.value }))} style={inputStyle} />
              </label>
              <label style={{ display: "flex", alignItems: "center", gap: 6, paddingBottom: 8, cursor: "pointer" }}>
                <input type="checkbox" checked={form.feeCollected}
                  onChange={e => setForm(f => ({ ...f, feeCollected: e.target.checked }))} />
                <span style={{ fontSize: 12, color: "#475569" }}>שולם</span>
              </label>
            </div>
          )}

          {/* Description */}
          <label style={labelStyle}>
            <span style={labelText}>תיאור</span>
            <textarea
              placeholder="תיאור קצר..."
              required
              autoFocus
              value={form.description}
              onChange={e => setForm(f => ({ ...f, description: e.target.value }))}
              style={{ ...inputStyle, flex: "0 0 auto", resize: "vertical", minHeight: "80px", fontFamily: "inherit" }}
            />
          </label>

          <div style={{ display: "flex", gap: 8, marginTop: 4 }}>
            <button type="submit" style={{
              flex: 1, padding: "10px 0", background: "#4338ca", color: "white",
              border: "none", borderRadius: 7, cursor: "pointer", fontWeight: 700, fontSize: 13,
            }}>שמור</button>
            <button type="button" onClick={onClose} style={{
              flex: "0 0 72px", padding: "10px 0", background: "white", color: "#64748b",
              border: "1px solid #e2e8f0", borderRadius: 7, cursor: "pointer", fontSize: 13,
            }}>ביטול</button>
          </div>
        </form>
      </div>
    </div>
  );
}

const iconBtn = {
  background: "transparent", border: "none", cursor: "pointer",
  fontSize: 16, color: "#94a3b8", padding: 4,
};
const labelStyle = { display: "flex", flexDirection: "column", gap: 4 };
const labelText = { fontSize: 11, fontWeight: 700, color: "#64748b", textAlign: "right" };
const inputStyle = {
  flex: 1, fontSize: 13, padding: "8px 10px",
  border: "1px solid #e2e8f0", borderRadius: 6,
  outline: "none", direction: "rtl", textAlign: "right",
  background: "white", width: "100%", boxSizing: "border-box",
};
